import { useVenue } from 'Shared/VenueProvider';
import {createContext,useContext} from 'solid-js';

export interface PathElement {
	key: string|number;
	classes?: string[];
}

interface IStylesContent {
	path: PathElement[]|null;
	styleTagAndPaths: ()=>TagAndPath[];
	setStyleTagAndPaths?: (tagAndPaths:TagAndPath[])=>void,

	/* Just used by OuterBasic.tsx */
	deferredClasses?: ()=>string[],
	setDeferredClasses?: ((func:()=>string[]) => void)
};

export interface TagAndPath {
	tag: string;
	pathWhenAdded: (string|number)[];
};


const StylesContext = createContext();

export function StylesProvider(P:{children} & IStylesContent)
{
	return (
		<StylesContext.Provider value={P}>
			{P.children}
		</StylesContext.Provider>
	);
}

export function useStyleTagAndPaths(): (()=>TagAndPath[])
{
	return useContext(StylesContext).styleTagAndPaths ?? (() => []);
}

export function useStylePath(): PathElement[]
{
	return useContext(StylesContext).path;
}

export function initPageStyles(data)
{
	const trimmedParentStyles = (useVenue().styles ?? []).filter(e => !(data.removeStyles ?? []).includes(e));

	const combinedStyleTags = [...trimmedParentStyles, ...(data.styles ?? [])];

	const stylePairs:TagAndPath[] = [];
	for (const tag of combinedStyleTags) 
		stylePairs.push({tag:tag,pathWhenAdded:[]});

	useContext(StylesContext).setStyleTagAndPaths(stylePairs);
	useContext(StylesContext).setDeferredClasses(data.classes);
}

/* Just used by OuterBasic.tsx */
export function useDeferredClasses(): (()=>string[])
{
	return useContext(StylesContext).deferredClasses;
}


